import { Bell } from 'lucide-react';
import { APP_ORIGIN, ROUTES } from '../config.ts';
import type { HomeData } from '../services/api.ts';
import { CowrieIcon, GeniusIcon } from './StatIcons.tsx';
import { Logo } from './Logo.tsx';

function compact(value: number): string {
  if (value < 1_000) return String(Math.round(value));
  if (value < 100_000) return `${(value / 1_000).toFixed(1).replace('.0', '')}k`;
  if (value < 1_000_000) return `${Math.round(value / 1_000)}k`;
  return `${(value / 1_000_000).toFixed(1).replace('.0', '')}m`;
}

export function GamesTopBar({ home, navigate }: { home: HomeData; navigate: (path: string) => void }) {
  return (
    <header className="games-topbar">
      <div className="games-topbar-row">
        <a className="header-stats" href={`${APP_ORIGIN}/profile/cowries`} aria-label="Your Genius points and Cowries">
          <span className="header-stat genius-stat"><GeniusIcon size={16} /><strong>{compact(home.stats.genius_points)}</strong></span>
          <span className="header-stat cowrie-stat"><CowrieIcon size={16} /><strong>{compact(home.stats.cowries)}</strong></span>
        </a>
        <div className="header-centre">
          <button type="button" className="header-logo" onClick={() => navigate(ROUTES.catalog)} aria-label="Games home">
            <Logo compact />
          </button>
        </div>
        <a className="header-icon" href={`${APP_ORIGIN}/notifications`} aria-label="Notifications">
          <Bell size={21} />
        </a>
      </div>
    </header>
  );
}

export function PublicTopBar() {
  return (
    <header className="games-topbar public-topbar">
      <div className="games-topbar-row">
        <span className="header-spacer" />
        <div className="header-centre"><Logo /></div>
        <span className="header-spacer" />
      </div>
    </header>
  );
}
